import { render, staticRenderFns } from "./noDataCard.vue?vue&type=template&id=56d7318a&"
import script from "./noDataCard.vue?vue&type=script&lang=js&"
export * from "./noDataCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports